export const ROUTES = {
  home: '/',
  products: '/products',
  tabletApp: '/tablet-app',
  affiliates: '/affiliates',
  partners: '/partners',
  buy: '/buy',
  contact: '/contact',
  login: '/login',
  dashboard: '/dashboard',
} as const;

export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES];

export interface NavLink {
  label: string;
  to: RoutePath;
}

/** Primary navigation, shared by the desktop header and the mobile drawer. */
export const PRIMARY_NAV: NavLink[] = [
  { label: 'Products', to: ROUTES.products },
  { label: 'Tablet App', to: ROUTES.tabletApp },
  { label: 'Affiliates', to: ROUTES.affiliates },
  { label: 'Partners', to: ROUTES.partners },
  { label: 'Buy', to: ROUTES.buy },
];

export const FOOTER_NAV: { title: string; links: NavLink[] }[] = [
  {
    title: 'Products',
    links: [
      { label: 'All products & pricing', to: ROUTES.products },
      { label: 'Tablet LaunchPads', to: ROUTES.tabletApp },
      { label: 'Order a LaunchPad', to: ROUTES.buy },
    ],
  },
  {
    title: 'Partners',
    links: [
      { label: 'Licensed affiliate platforms', to: ROUTES.affiliates },
      { label: 'List your platform', to: ROUTES.partners },
      { label: 'Contact us', to: ROUTES.contact },
    ],
  },
  {
    title: 'Operators',
    links: [
      { label: 'Operator login', to: ROUTES.login },
      { label: 'How it works', to: ROUTES.home },
    ],
  },
];
